import React from 'react';
import styles from '../SaleReportPage.module.scss';

function PhotoCard({ url, order, isCover, onRemove }) {
  return (
    <div
      className={`${styles.photoCard} ${isCover ? styles.photoCardCover : ''}`}
      style={{ backgroundImage: `url(${url})` }}
    >
      <span className={styles.photoCardOrder}>
        {String(order).padStart(2, '0')}
      </span>
      {onRemove && (
        <button
          type="button"
          className={styles.photoCardRemove}
          onClick={onRemove}
          aria-label="삭제"
        >
          &times;
        </button>
      )}
    </div>
  );
}

export default PhotoCard;
